import React, { useEffect, useState } from "react";
import { getCategoryUrl } from "../../../utils/urls";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Skeleton from "../../../components/Skeleton";

function SelectCategory({ selectedCategory, onNext, onBack, onUpdate }) {
  const [localSelectedCategory, setLocalSelectedCategory] = useState(selectedCategory || null);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    axios
      .get(getCategoryUrl + "?is_active=true&is_all=true")
      .then((res) => {
        const data = res.data?.data?.filter(cat => cat.is_active && !cat.is_delete) || [];
        setCategory(data);
      })
      .catch((err) => {
        console.log(err?.response);
      })
      .finally(() => setLoading(false));
  };

  const skeletonArray = Array(6).fill(null);

  const handleSaveNext = () => {
    if (localSelectedCategory) {
      onUpdate(localSelectedCategory);
      onNext();
    }
  };

  return (
    <div className="pt-4 border-t border-[#E2EBF3]">
      <p className="text-[1rem] font-semibold text-[#2C2C2C] mb-4">Select a Category</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 h-[calc(100vh_-_24rem)] overflow-y-auto">
        {(loading ? skeletonArray : category).map((cat, index) => {
          const isSelected = cat?.category_id === localSelectedCategory?.category_id;
          return (
            <div
              key={cat?.category_id || index}
              onClick={() => cat && setLocalSelectedCategory(cat)}
              className={`bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 p-6 border 
                ${isSelected ? "border-blue-600 ring-2 ring-blue-100" : "border-gray-100"} 
                flex flex-col cursor-pointer`}
            >
              <div className="flex items-center gap-4 mb-4">
                {cat?.logo_url ? (
                  <img
                    src={cat.logo_url}
                    alt={cat.title}
                    className="w-14 h-14 object-contain rounded-full border border-gray-200"
                  />
                ) : (
                  <Skeleton className="w-14 h-14 rounded-full" />
                )}
                {cat?.title ? (
                  <h2 className="text-lg font-semibold text-gray-800">{cat.title}</h2>
                ) : (
                  <div className="flex-1 space-y-2">
                    <Skeleton className="h-4 w-32 rounded" />
                    <Skeleton className="h-3 w-20 rounded" />
                  </div>
                )}
              </div>

              {cat?.description ? (
                <p className="text-sm text-gray-600 overflow-hidden text-ellipsis" style={{ maxHeight: "4.5em" }}>
                  {cat.description}
                </p>
              ) : (
                <div className="space-y-1">
                  <Skeleton className="h-3 w-full rounded" />
                  <Skeleton className="h-3 w-5/6 rounded" />
                  <Skeleton className="h-3 w-4/5 rounded" />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {!loading && category.length === 0 && (
        <div className="text-center py-12 text-gray-500 font-medium">
          No categories available.
        </div>
      )}

      <div className="flex justify-between gap-4 mt-6">
        <button
          type="button"
          onClick={onBack}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100"
        >
          Back
        </button>
        <button
          type="button"
          onClick={handleSaveNext}
          disabled={!localSelectedCategory}
          className={`px-4 py-2 rounded-md text-white ${
            localSelectedCategory ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
          }`}
        >
          Save & Next
        </button>
      </div>
    </div>
  );
}

export default SelectCategory;
